// Generated by ReScript, PLEASE EDIT WITH CARE


function getVersionFromStr(name) {
  var match = name.toLowerCase();
  switch (match) {
    case "v2" :
        return "V2";
    default:
      return "V1";
  }
}

var sdkVersion = getVersionFromStr(sdkVersionValue);

var targetOrigin = "*";

export {
  getVersionFromStr ,
  sdkVersion ,
  targetOrigin ,
}
/* sdkVersion Not a pure module */
